export enum FeatureTogglesEnums {
  ResultsAccessOnly = 'results-access-only',
}
